import React from 'react';
import { render } from 'react-dom';
import traceUFOPageLoad from '@atlaskit/react-ufo/trace-pageload';
import { provideHealthcheck } from '@atlassian/jira-common-healthcheck/src/utils/healthcheck-utils/index.tsx';
import { JiraContextContainer } from '@atlassian/jira-context-container/src/index.tsx';
import { GlobalBottomRightCornerContainer } from '@atlassian/jira-layout-controller/src/ui/bottom-right-corner/container/index.tsx';
import {
	isConfluenceReportView,
	isEmbedReportView,
} from '@atlassian/jira-portfolio-3-portfolio/src/common/window/index.tsx';
import { StrictMode } from '@atlassian/jira-react-strict-mode/src/index.tsx';
import PlanConfluenceEmbedWrapper from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-confluence-embed/index.tsx';
import initReactUFO from '@atlassian/jira-ufo-interaction-metrics-init/src/index.tsx';
import global from '../global.tsx';

const FOOTER_OFFSET_PX = 48;

provideHealthcheck();
global.install();

// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const container = document.getElementById('jira-frontend');

const getUFOName = () => {
	if (isConfluenceReportView()) return 'software-plan-reports-confluence-macro';
	if (isEmbedReportView()) return 'software-plan-reports-embedded-view';
};

if (container) {
	initReactUFO();
	traceUFOPageLoad(getUFOName());

	render(
		<StrictMode>
			<JiraContextContainer>
				<PlanConfluenceEmbedWrapper />
				<GlobalBottomRightCornerContainer bottomOffset={FOOTER_OFFSET_PX} />
			</JiraContextContainer>
		</StrictMode>,
		container,
	);
}
